import { useCallback } from 'react';
import { usePreferredCurrencyExchangeRate } from './useFetchPortalExchangeRates';
export const useConvertCompanyCurrencyToDisplayCurrency = () => {
  const exchangeRate = usePreferredCurrencyExchangeRate();
  return useCallback(companyCurrency => companyCurrency * (1 / exchangeRate), [exchangeRate]);
};
export const useConvertDisplayCurrencyToCompanyCurrency = () => {
  const exchangeRate = usePreferredCurrencyExchangeRate();
  return useCallback(displayCurrency => displayCurrency * exchangeRate, [exchangeRate]);
};